import { render, staticRenderFns } from "./AboutCoopnetComponent.vue?vue&type=template&id=5e8f3a1f&scoped=true&"
import script from "./AboutCoopnetComponent.vue?vue&type=script&lang=js&"
export * from "./AboutCoopnetComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutCoopnetComponent.vue?vue&type=style&index=0&id=5e8f3a1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f3a1f",
  null
  
)

export default component.exports